// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"261":"september-thomas","345":"portfolio","570":"zauvu","594":"about","752":"quick-buck"}[chunkId] + "." + {"261":"3e95d458","345":"675bd151","570":"cbd8d64e","594":"8ade8ddb","752":"0e462bc8"}[chunkId] + ".js";
};